import React from 'react'
import ThemeSF from '../components/common/ThemeSF'
import './HeaderRight.css'

const PublicHeaderRightUI = ({context, messageList}) =>
  <div className='t_hdr_rgt g_flex_h'>
    <ThemeSF context={context} />
  </div>

export default PublicHeaderRightUI
